<div class="flex justify-center mt-15 mb-15 2xs:mt-45 md-home-2:mt-50 lg:mt-65 lg:mb-20  w-full">
  <div class="flex flex-col w-[90rem] h-[300px] 2xs:h-[340px] sm:h-[380px] sm-home:h-[420px] md:h-[540px] md-home-2:h-[640px] lg:w-2/3 2xl:w-1/2 lg:h-auto p-5 ">
    <video class="w-full border-theme-black border-3 rounded-2xl" autoplay loop muted playsinline preload="none" id="welcome-video">
      <source id="source-desktop" type="video/webm" media="(min-width: 600px)" />
      <source id="source-mobile" type="video/webm" media="(max-width: 600px)" />
    </video>
  </div>
</div>
